import * as React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import { useAppUpdatesContext } from '@app/app/src/AppContext';
import { useBundleUrlFilterSync } from '../../hooks';

const messages = defineMessages({
  label: {
    id: 'appUpdates.bundles.filters.apply.label',
    defaultMessage: 'Apply',
    description: 'Label for the bundled changes apply filters button',
  },
});

export const BundleApplyButton: React.FC = () => {
  const { formatMessage } = useIntl();
  const { state, dispatch } = useAppUpdatesContext();
  const { syncFiltersToUrl } = useBundleUrlFilterSync();

  const handleClick = React.useCallback(() => {
    syncFiltersToUrl({
      ...state.bundles.draftFilters,
      cursor: undefined,
    });

    dispatch({ type: 'BUNDLES_FILTERS_APPLY' });
    // TODO: analytics — fire bundled-changes apply event (specifics TBD).
  }, [dispatch, state.bundles.draftFilters, syncFiltersToUrl]);

  return (
    <Button
      testId="app-updates-bundle-apply-filter-button"
      onClick={handleClick}
      appearance="primary"
    >
      {formatMessage(messages.label)}
    </Button>
  );
};
